//WMS - 入库管理api
import {ServerDistApi} from '@/group-cloud/network/ServerBizApi';

//配置下拉框值集
export const All_Sel_Option = '';
//配货方式
export const Customer_Types_Opts = {
    zero:{ key:'', name:'全部'},
    active: { key:0, name:'门店要货'},
    distribution: {key:1, name:'主动配货'}}

//库存状态
export const Mod_StockStatus_Types = {
    ZERO: 1,  //待审批
    ONE:  2,  //待发货
    TWO:  3,  //已推单
    THREE: 4, //已完成
    FOUR: 5, //已关闭
}

export const Mod_StockStatus_Options = [
    {id: All_Sel_Option, label: '全部'},
    {id: Mod_StockStatus_Types.ZERO, label: '待审批'},
    {id: Mod_StockStatus_Types.ONE, label: '待发货'},
    {id: Mod_StockStatus_Types.TWO, label: '已推单'},
    {id: Mod_StockStatus_Types.THREE, label: '已完成'},
    {id: Mod_StockStatus_Types.FOUR, label: '已关闭'},
];
export class getPrepareList {

    constructor() {
    }
    protected static groupUrl = '/scan/goods';
    //库存查询
    // http://47.95.206.72:3001/mock/13/data-dist/api/dist/scan/goods/stock/account/query
    // https://api.pre.mzdata.top/data-dist/api/dist/wms/bill/out/list
    // http://47.95.206.72:3001/mock/13/data-dist/api/dist/scan/goods/list
    // http://localhost:8087/data-dist/api/dist/scan/goods/get_store_by_uid
    // http://47.95.206.72:3001/mock/13/data-dist/api/dist/scan/goods/details/detailed
    // http://47.95.206.72:3001/mock/13/data-dist/api/dist/scan/goods//items/list
    //配货管理列表数据
    public static async getPriceList(data) {
        let uri = this.groupUrl + '/list';
        return await ServerDistApi.send(uri, data);
    }
    //配货管理详情数据
    public static async getPriceDetailList(data) {
        let uri = this.groupUrl + '/details';
        return await ServerDistApi.send(uri,data);
    }
    //审批
    public static async ApprovalDetail(data) {
        let uri = this.groupUrl + '/examine';
        return await ServerDistApi.send(uri,data);
    }
    //订货管理-详情-配货明细
    public static async ApprovalDetailed(data) {
        let uri = this.groupUrl + '/details/detailed';
        return await ServerDistApi.send(uri,data);
    }
    //新增商品列表
    public static async getAddList(data) {
        let uri = this.groupUrl + '//items/list';
        return await ServerDistApi.send(uri,data);
    }
    //导出
    public static async getOut(data) {
        let uri = this.groupUrl + '/exportScanWayGoodsOrder';
        return await ServerDistApi.send(uri,data);
    }

    //新增--详情
    public static async getDetail(data) {
        let uri = this.groupUrl +  '/stock/account/query';
        return await ServerDistApi.send(uri,data);
    }
   

    //获取用户信息--门店信息
    public static async getUserList(data) {
        let uri = this.groupUrl + '/selectStoreList?token='+data;
        return await ServerDistApi.send(uri,null);
    }
    
    //获取用户信息--关闭订单
    public static async closeFundAccount(data) {
        let uri = '/scanWayBill/close?orderNo='+data;
        return await ServerDistApi.send(uri,null);
    }
    //获取用户信息--门店信息
    public static async getOrder(data) {
        let uri = '/scanWayBill/queryOrder';
        return await ServerDistApi.send(uri,data);
    }
    // 发货
    public static async putData(data) {
        let uri = '/scanWayBill/deliverGoods';
        return await ServerDistApi.send(uri,data);
    }
    // 添加sn码
    public static async AddData(data) {
        let uri = '/scanWayBill/sweep';
        return await ServerDistApi.send(uri,data);
    }
    // 添加sn盒码
    public static async AddDatas(data) {
        let uri = '/scanWayBill/sweepBox';
        return await ServerDistApi.send(uri,data);
    }
     // 查看sn码
     public static async lookData(data) {
        let uri = '/scanWayBill/snDetail';
        return await ServerDistApi.send(uri,data);
    }
    // /data-dist/api/dist/scanWayBill/snRemove
   // 删除sn码
   public static async deleteData(data) {
    let uri = '/scanWayBill/snRemove';
    return await ServerDistApi.send(uri,data);
}
}


